import Icon from '../components/Icon.vue'

Icon.register({
  train: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 96V352C448 403.8 386.4 448 318 448L381 497.7C386.9 502.4 383.6 512 376 512H72C64.4 512 61.1 502.4 67 497.7L130 448C61.8 448 0 404 0 352V96C0 43 64 0 128 0H320C385 0 448 43 448 96zM400 232V120C400 106.7 389.3 96 376 96H72C58.7 96 48 106.7 48 120V232C48 245.3 58.7 256 72 256H376C389.3 256 400 245.3 400 232zM224 296C193.1 296 168 321.1 168 352S193.1 408 224 408 280 382.9 280 352 254.9 296 224 296z'
      }
    ]
  }
})
